(() => {
  const TARGET = 'walk-explore-set';
  const PRODUCT = {
    tracker: 'smart-pet-tracker-collar-dual-system-tracking-no-monthly-fee',
    harness: 'soft-no-pull-cat-harness-leash-set-comfortable-adjustable-walking-vest-for-cats-small-dogs',
    bottle: 'portable-dog-water-bottle-with-food-storage-2-in-1-travel-bottle-for-dogs-cats'
  };
  const TRACKER_GROUPS = {
    black: [
      'https://cdn.shopify.com/s/files/1/1013/7740/9341/files/ChatGPT_Image_2026_9_3_22_18_28.png?v=1788448470',
      'https://cdn.shopify.com/s/files/1/1013/7740/9341/files/2cf8b1c5-416b-46a2-833c-7ecdf44b8e46.png?v=1788667847',
      'https://cdn.shopify.com/s/files/1/1013/7740/9341/files/18903a66-9771-49e4-8545-8887ca53e47d.png?v=1788630461',
      'https://cdn.shopify.com/s/files/1/1013/7740/9341/files/97b1eb69-4a5f-49d5-b839-6d29f4edf461.png?v=1788630460',
      'https://cdn.shopify.com/s/files/1/1013/7740/9341/files/fbf76740-2348-43b7-93b8-9003c2b928ad.png?v=1788630460',
      'https://cdn.shopify.com/s/files/1/1013/7740/9341/files/0766c2e6-1a77-466d-b541-8f0856e82371.png?v=1788667899'
    ],
    pink: [
      'https://cdn.shopify.com/s/files/1/1013/7740/9341/files/ChatGPT_Image_2026_9_3_22_46_45.png?v=1788448470',
      'https://cdn.shopify.com/s/files/1/1013/7740/9341/files/1e513d35-5613-43ac-9593-e265ea78da8f.png?v=1788664065',
      'https://cdn.shopify.com/s/files/1/1013/7740/9341/files/a4c8b32f-ea63-4afc-a3a4-153ef600088a.png?v=1788664072',
      'https://cdn.shopify.com/s/files/1/1013/7740/9341/files/1f0713e4-2313-406c-8c50-69c76271db4a.png?v=1788664072',
      'https://cdn.shopify.com/s/files/1/1013/7740/9341/files/ac2c08c6-7240-4355-96b9-c75d72a2fa88.png?v=1788668126',
      'https://cdn.shopify.com/s/files/1/1013/7740/9341/files/1d9a543d-c0a6-4bf2-9734-1314e85ca21d.png?v=1788664071'
    ]
  };

  const norm = v => String(v || '').replace(/\s+/g, ' ').trim().toLowerCase();
  const currentHandle = () => {
    const match = location.pathname.match(/\/products\/([^/?#]+)/i);
    return match ? decodeURIComponent(match[1]).toLowerCase() : '';
  };
  if (currentHandle() !== TARGET) return;

  const lockNativeBundlePricing = () => {
    document.querySelectorAll('[data-powlife-product]').forEach(root => {
      root.dataset.walkExploreUpgradeReady = 'true';
    });
  };
  lockNativeBundlePricing();
  document.addEventListener('shopify:section:load', lockNativeBundlePricing);

  const cache = new Map();
  const fetchProduct = handle => {
    if (!cache.has(handle)) {
      cache.set(handle, fetch(`/products/${handle}.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      }).then(r => {
        if (!r.ok) throw new Error(`Unable to load ${handle}`);
        return r.json();
      }));
    }
    return cache.get(handle);
  };
  const imageSrc = image => {
    if (!image) return '';
    if (typeof image === 'string') return image;
    return image.src || image.url || image.preview_image?.src || image.preview_image?.url || '';
  };
  const imageKey = src => {
    try { return new URL(src || '', location.origin).pathname.replace(/_(?:pico|icon|thumb|small|compact|medium|large|grande|original|master|\d+x\d*|x\d+)(?=\.[a-z0-9]+$)/i, ''); }
    catch (_) { return String(src || '').split('?')[0]; }
  };
  const optionName = option => typeof option === 'string' ? option : option?.name || '';
  const colorIndex = product => {
    const i = (product?.options || []).findIndex(option => /colou?r/i.test(optionName(option)));
    return i >= 0 ? i : 0;
  };
  const colorVariant = (product, color) => {
    const i = colorIndex(product);
    const variants = product?.variants || [];
    return variants.find(v => norm(v.options?.[i]) === norm(color) && v.available)
      || variants.find(v => norm(v.options?.[i]) === norm(color))
      || variants.find(v => v.available)
      || variants[0]
      || null;
  };
  const mediaList = product => (product?.media || []).map(media => ({
    src: imageSrc(media),
    alt: String(media?.alt || '').trim(),
    type: String(media?.media_type || 'image').toLowerCase()
  })).filter(item => item.src && (!item.type || item.type === 'image'));
  const exactAltGroup = (product, color) => {
    const wanted = norm(color);
    if (!wanted) return [];
    return mediaList(product).filter(item => {
      const alt = norm(item.alt);
      return alt === wanted || alt.includes(wanted) || wanted.includes(alt) && alt.length > 2;
    });
  };
  const positionalGroup = (product, color) => {
    const hero = imageSrc(colorVariant(product, color)?.featured_image);
    const images = (product?.images || []).map(imageSrc).filter(Boolean);
    if (!hero || !images.length) return [];
    const heroKey = imageKey(hero);
    const start = images.findIndex(src => imageKey(src) === heroKey);
    if (start < 0) return [];

    const i = colorIndex(product);
    const heroKeys = [];
    const seenColors = new Set();
    (product?.variants || []).forEach(v => {
      const c = norm(v.options?.[i]);
      const src = imageSrc(v.featured_image);
      if (!c || !src || seenColors.has(c)) return;
      seenColors.add(c);
      heroKeys.push(imageKey(src));
    });
    const heroKeySet = new Set(heroKeys);
    let end = images.length;
    for (let p = start + 1; p < images.length; p += 1) {
      if (heroKeySet.has(imageKey(images[p]))) { end = p; break; }
    }
    return images.slice(start, end);
  };
  const fallbackGroup = (product, color) => {
    const hero = imageSrc(colorVariant(product, color)?.featured_image);
    const i = colorIndex(product);
    const colorHeroes = new Set();
    const seenColors = new Set();
    (product?.variants || []).forEach(v => {
      const c = norm(v.options?.[i]);
      if (!c || seenColors.has(c)) return;
      seenColors.add(c);
      const src = imageSrc(v.featured_image);
      if (src) colorHeroes.add(imageKey(src));
    });
    const shared = (product?.images || []).map(imageSrc).filter(Boolean).filter(src => !colorHeroes.has(imageKey(src)));
    return [hero, ...shared].filter(Boolean);
  };
  const fullGroupForColor = (product, color) => {
    const exact = exactAltGroup(product, color);
    if (exact.length > 1) return exact.map(item => item.src);
    const positional = positionalGroup(product, color);
    if (positional.length > 1) return positional;
    return fallbackGroup(product, color);
  };

  const selectedVirtual = group => group?.querySelector('[data-walk-value].is-selected')?.dataset.walkValue || '';
  const selectedNative = group => group?.querySelector('[data-option-value].is-selected')?.dataset.optionValue || '';
  const findHarnessGroup = root => [...root.querySelectorAll('.pl-option, [data-option-position]')].find(group => {
    const text = (group.querySelector('legend')?.textContent || '').split(':')[0].trim();
    return norm(text) === norm('Harness & Leash Color');
  });

  const ensureStyles = () => {
    if (document.getElementById('walk-gallery-restore-styles')) return;
    const style = document.createElement('style');
    style.id = 'walk-gallery-restore-styles';
    style.textContent = `
      .pl-gallery.pl-gallery--walk-scattered{display:block!important}
      .pl-gallery.pl-gallery--walk-scattered>.pl-gallery__thumbs,.pl-gallery.pl-gallery--walk-scattered>.pl-gallery__stage{display:none!important}
      .pl-gallery.pl-gallery--walk-scattered>.pl-gallery__stack{display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr))!important;gap:14px!important;width:100%!important}
      .pl-gallery.pl-gallery--walk-scattered .pl-gallery__item{position:relative;aspect-ratio:1/1;margin:0;overflow:hidden;background:#f6f6f2}
      .pl-gallery.pl-gallery--walk-scattered .pl-gallery__stack-image{display:block;width:100%;height:100%;object-fit:contain;object-position:center}
      .pl-gallery.pl-gallery--walk-scattered .pl-gallery__item .pl-gallery__badge{position:absolute;left:18px;top:18px}
      @media(max-width:749px){.pl-gallery.pl-gallery--walk-scattered>.pl-gallery__stack{grid-template-columns:1fr!important;gap:12px!important}.pl-gallery.pl-gallery--walk-scattered .pl-gallery__item .pl-gallery__badge{left:14px;top:14px}}
    `;
    document.head.appendChild(style);
  };

  const initGalleryRestore = async () => {
    const root = document.querySelector('[data-powlife-product]');
    if (!root || root.dataset.walkGalleryRestoreReady === 'true') return;
    const trackerGroup = root.querySelector('[data-walk-virtual="Tracker Color"]');
    const bottleGroup = root.querySelector('[data-walk-virtual="Bottle Color"]');
    const harnessGroup = findHarnessGroup(root);
    const gallery = root.querySelector('.pl-gallery');
    if (!trackerGroup || !bottleGroup || !harnessGroup || !gallery) return;

    root.dataset.walkGalleryRestoreReady = 'true';
    ensureStyles();
    const fallback = [...gallery.querySelectorAll('[data-gallery-thumb]')].map(thumb => ({
      src: thumb.dataset.src || thumb.querySelector('img')?.src || '',
      alt: thumb.dataset.galleryAlt || ''
    })).filter(item => item.src);
    const badge = gallery.querySelector('.pl-gallery__badge')?.cloneNode(true);
    let stack = gallery.querySelector('.pl-gallery__stack');
    if (!stack) {
      stack = document.createElement('div');
      stack.className = 'pl-gallery__stack';
      gallery.insertBefore(stack, gallery.firstChild);
    }
    gallery.classList.add('pl-gallery--walk-scattered');

    const loaded = {};
    await Promise.all(Object.entries(PRODUCT).map(async ([key, handle]) => {
      try { loaded[key] = await fetchProduct(handle); } catch (_) { loaded[key] = null; }
    }));

    const render = (urls, label) => {
      const seen = new Set();
      const list = [];
      (urls || []).forEach(item => {
        const entry = typeof item === 'string' ? { src: item, alt: '' } : item;
        const key = imageKey(entry.src);
        if (!entry.src || !key || seen.has(key)) return;
        seen.add(key);
        list.push(entry);
      });
      const source = list.length ? list : fallback;
      if (!source.length) return;
      const frag = document.createDocumentFragment();
      source.forEach((item, i) => {
        const figure = document.createElement('figure');
        figure.className = 'pl-gallery__item';
        figure.dataset.galleryGroup = label || 'walk';
        const img = document.createElement('img');
        img.className = 'pl-gallery__stack-image';
        img.src = item.src;
        img.alt = item.alt || `${label || 'Walk & Explore'} - image ${i + 1}`;
        img.loading = i < 2 ? 'eager' : 'lazy';
        img.decoding = 'async';
        figure.appendChild(img);
        frag.appendChild(figure);
      });
      stack.replaceChildren(frag);
      if (badge && stack.firstElementChild) stack.firstElementChild.appendChild(badge.cloneNode(true));
    };

    let active = 'tracker';
    let token = 0;
    const show = key => {
      let color = '';
      if (key === 'tracker') color = selectedVirtual(trackerGroup);
      else if (key === 'bottle') color = selectedVirtual(bottleGroup);
      else if (key === 'harness') color = selectedNative(harnessGroup);
      if (!color) return;
      active = key;
      const myToken = ++token;
      const product = loaded[key];
      const urls = key === 'tracker' && TRACKER_GROUPS[norm(color)]
        ? TRACKER_GROUPS[norm(color)]
        : product ? fullGroupForColor(product, color) : [];
      if (myToken === token) render(urls, `${key}:${color}`);
    };

    render(fallback, 'bundle');
    show('tracker');
    root.addEventListener('click', event => {
      const button = event.target.closest('[data-walk-value],[data-option-value]');
      if (!button || !root.contains(button)) return;
      const group = button.closest('.pl-option, [data-option-position]');
      if (group === trackerGroup) setTimeout(() => show('tracker'), 30);
      else if (group === bottleGroup) setTimeout(() => show('bottle'), 30);
      else if (group === harnessGroup) setTimeout(() => show('harness'), 30);
    }, true);
    root.querySelector('[data-variant-select]')?.addEventListener('change', () => setTimeout(() => show(active), 50));
  };

  const boot = () => {
    lockNativeBundlePricing();
    let tries = 0;
    const timer = setInterval(() => {
      initGalleryRestore();
      tries += 1;
      if (document.querySelector('[data-powlife-product]')?.dataset.walkGalleryRestoreReady === 'true' || tries > 40) clearInterval(timer);
    }, 80);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', () => setTimeout(boot, 0));
})();
